/* =====================================================================
   NO SUGAR – Reglas de compra 2027 (funciones puras, sin DOM)
   Requiere: ns-rotation2027.js cargado antes.
   Fuente de verdad: el carrito de Shopify. localStorage nunca decide reglas.
   Se usa en las tres páginas y en las pruebas de Node.
   ===================================================================== */
(function (global) {
  'use strict';

  function Rot() { return global.NSRotation; }

  var MIN_ALC = 5;          // por semana, solo líneas A la carta (más personalizados si ctx.customCountsAlc)
  var CUSTOM_KIND = 'Personalizado'; // CUSTOM 2027: valor de "Tipo de compra" de Custom Meal y Custom Breakfast
  // CUSTOM 2027: true = los personalizados suman al mínimo de 5 por semana de A la carta.
  // false = no suman y no tienen mínimo propio. Pendiente de confirmar por No Sugar.
  var CUSTOM_COUNTS_ALC = true;
  var MIN_EXPRESS = 5;      // por pedido, total
  var PLAN_WINDOW = 4;      // semanas a elegir en Planes. 4 = cada menú (Menu1..Menu4) aparece una sola vez,
                            // así el inventario de cada SKU es la oferta real de una sola semana.
  var ALC_WEEKS = 4;        // A la carta: las próximas 4 semanas
  var PLANS = ['Slim', 'Healthy', 'Stronger', 'Keto'];
  var TIMES = {
    '1': [['Des', 'Desayuno'], ['Com', 'Comida'], ['Cen', 'Cena']],
    '2': [['Des-Com', 'Desayuno y comida'], ['Com-Cen', 'Comida y cena'], ['Des-Cen', 'Desayuno y cena']],
    '3': [['Completo', 'Desayuno, comida y cena']]
  };
  var DAYS = { '5': [5, 10, 20], '6': [6, 12, 24], '7': [7, 14, 28] };

  /* ---------- Texto ---------- */
  function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
  function dishes(n) { return plural(n, 'platillo', 'platillos'); }

  /* ---------- Configuración de Planes ---------- */
  function weeksForDays(td) { td = +td; return td <= 7 ? 1 : (td <= 14 ? 2 : 4); }
  function timeOptions(pd) { return TIMES[String(pd)] || []; }
  function durationOptions(days) {
    return (DAYS[String(days)] || []).map(function (td) { return { days: td, weeks: weeksForDays(td) }; });
  }
  function timesLabel(v) {
    var all = TIMES['1'].concat(TIMES['2'], TIMES['3']);
    for (var i = 0; i < all.length; i++) if (all[i][0] === v) return all[i][1];
    return '';
  }

  // c: { plan, pd, times, days, td } → plan completo o null si la combinación no existe.
  function buildPlan(c) {
    if (!c || PLANS.indexOf(c.plan) === -1) return null;
    var n = parseInt(c.pd, 10);
    if (!timeOptions(n).some(function (o) { return o[0] === c.times; })) return null;
    var td = parseInt(c.td, 10);
    var days = parseInt(c.days, 10);
    if (!DAYS[String(days)] || DAYS[String(days)].indexOf(td) === -1) return null;
    var weeks = weeksForDays(td);
    var daysPerWeek = td / weeks;
    var perWeek = n * daysPerWeek;
    return {
      plan: c.plan, n: n, times: c.times, td: td, daysPerWeek: daysPerWeek,
      weeks: weeks, perWeek: perWeek, total: perWeek * weeks,
      code: c.plan + n + '-' + c.times + '-' + td
    };
  }

  var CODE_RE = /^(slim|healthy|stronger|keto)([123])-(des|com|cen|des-com|com-cen|des-cen|completo)-(\d+)$/i;
  function parseBundleCode(code) {
    var m = CODE_RE.exec(String(code || '').trim());
    if (!m) return null;
    var plan = PLANS.filter(function (p) { return p.toLowerCase() === m[1].toLowerCase(); })[0];
    var times = timeOptions(m[2]).map(function (o) { return o[0]; })
      .filter(function (t) { return t.toLowerCase() === m[3].toLowerCase(); })[0];
    var td = parseInt(m[4], 10);
    var days = Object.keys(DAYS).filter(function (d) { return DAYS[d].indexOf(td) > -1; })[0];
    return buildPlan({ plan: plan, pd: m[2], times: times, days: days, td: td });
  }

  /* ---------- Semanas ---------- */
  function addWeeks(monday, n) { return new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 7 * n); }
  function weekInfo(monday) {
    var R = Rot();
    return { monday: monday, id: R.isoWeekIdOf(monday), iso: R.isoWeekNumberOf(monday), menu: R.menuForMonday(monday) };
  }
  // Semanas a partir de la siguiente (offset 1..count).
  function upcomingWeeks(count, base) {
    base = base || Rot().currentMonday();
    var out = [];
    for (var off = 1; off <= count; off++) {
      var w = weekInfo(addWeeks(base, off));
      w.offset = off;
      out.push(w);
    }
    return out;
  }
  function currentWeek(base) {
    var w = weekInfo(base || Rot().currentMonday());
    w.offset = 0;
    return w;
  }

  var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  // "9 – 15 nov" o "30 nov – 6 dic"
  function weekLabel(monday) {
    var sun = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6);
    if (sun.getMonth() === monday.getMonth()) return monday.getDate() + ' – ' + sun.getDate() + ' ' + MONTHS[sun.getMonth()];
    return monday.getDate() + ' ' + MONTHS[monday.getMonth()] + ' – ' + sun.getDate() + ' ' + MONTHS[sun.getMonth()];
  }
  // "la semana del 9 nov"
  function weekShort(monday) { return 'la semana del ' + monday.getDate() + ' ' + MONTHS[monday.getMonth()]; }

  // Ventana de entrega existente (sin cambios): 3 días antes del lunes de consumo hasta el lunes.
  function deliveryWindow(monday) {
    var start = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() - 3);
    var o = { day: 'numeric', month: 'long' };
    return start.toLocaleDateString('es-MX', o) + ' - ' + monday.toLocaleDateString('es-MX', o);
  }
  // Versión para leer: "entre el 6 y el 9 de nov"
  function deliveryPhrase(monday) {
    var start = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() - 3);
    if (start.getMonth() === monday.getMonth()) {
      return 'entre el ' + start.getDate() + ' y el ' + monday.getDate() + ' de ' + MONTHS[monday.getMonth()];
    }
    return 'entre el ' + start.getDate() + ' de ' + MONTHS[start.getMonth()] + ' y el ' + monday.getDate() + ' de ' + MONTHS[monday.getMonth()];
  }

  /* ---------- Lectura del carrito ---------- */
  function props(it) { return (it && it.properties) || {}; }
  function qtyOf(it) { return parseInt(it && it.quantity, 10) || 0; }

  // Id de semana de una línea. Usa "Semana ID"; si no existe (líneas anteriores), busca el número ISO en las semanas conocidas.
  function lineWeekId(it, weeks) {
    var p = props(it);
    if (p['Semana ID']) return String(p['Semana ID']);
    var n = parseInt(String(p.Semana == null ? '' : p.Semana).replace(/\D+/g, ''), 10);
    if (!n) return '';
    var w = (weeks || []).filter(function (x) { return x.iso === n; })[0];
    return w ? w.id : 'iso-' + n;
  }

  /* ---------- Paquetes de plan ---------- */
  // Un mismo plan (BundleCode) puede ir más de una vez en el pedido, por ejemplo para la pareja.
  // La propiedad visible "Plan #" (1, 2, …) separa cada paquete. Clave interna: "BundleCode#n".
  function planKey(code, n) { return String(code || '') + '#' + (parseInt(n, 10) || 1); }
  function splitPlanKey(key) {
    var m = /^(.*)#(\d+)$/.exec(String(key || ''));
    return m ? { code: m[1], n: +m[2] } : { code: String(key || ''), n: 1 };
  }
  function linePlanKey(it) { var p = props(it); return planKey(p.BundleCode, p['Plan #']); }
  // Siguiente número de paquete libre para un plan.
  function nextPlanNumber(cart, code) {
    var max = 0;
    summarize(cart, []).planOrder.forEach(function (k) { var x = splitPlanKey(k); if (x.code === code) max = Math.max(max, x.n); });
    return max + 1;
  }

  function summarize(cart, weeks) {
    var R = Rot();
    var s = { qty: 0, express: { qty: 0, lines: [], weeks: {} }, alc: { qty: 0, lines: [], weeks: {} }, plans: {}, planOrder: [], other: [],
      custom: { qty: 0, lines: [], weeks: {}, groups: {}, order: [] } };
    ((cart && cart.items) || []).forEach(function (it, index) {
      var q = qtyOf(it);
      if (!q) return;
      var kind = R.cartKind(it);
      var wid = lineWeekId(it, weeks);
      var ref = { item: it, index: index, weekId: wid, qty: q };
      // CUSTOM 2027: un platillo personalizado = 1 línea "platillo" + sus líneas "ingrediente" (mismo _ns_cm).
      // Solo la línea "platillo" cuenta como platillo; los ingredientes solo llevan el precio.
      if (kind === CUSTOM_KIND) {
        var p = props(it), gid = String(p._ns_cm || ''), isDish = p._ns_cm_rol === 'platillo';
        s.custom.lines.push(ref);
        if (!s.custom.groups[gid]) { s.custom.groups[gid] = { id: gid, dish: null, parts: [], weekId: wid, qty: 0, expected: 0 }; s.custom.order.push(gid); }
        var g = s.custom.groups[gid];
        if (isDish) {
          g.dish = ref; g.qty = q; g.weekId = wid; g.expected = parseInt(p._ns_cm_n, 10) || 0;
          s.qty += q; s.custom.qty += q;
          s.custom.weeks[wid] = (s.custom.weeks[wid] || 0) + q;
        } else {
          g.parts.push(ref);
        }
        return;
      }
      s.qty += q;
      if (kind === 'Express') {
        s.express.qty += q; s.express.lines.push(ref);
        s.express.weeks[wid] = (s.express.weeks[wid] || 0) + q;
      } else if (kind === 'Planes') {
        var key = linePlanKey(it), kx = splitPlanKey(key);
        if (!s.plans[key]) { s.plans[key] = { key: key, code: kx.code, n: kx.n, cfg: parseBundleCode(kx.code), total: 0, perWeek: {}, lines: [] }; s.planOrder.push(key); }
        var pl = s.plans[key];
        pl.total += q; pl.lines.push(ref);
        pl.perWeek[wid] = (pl.perWeek[wid] || 0) + q;
      } else if (!wid) {
        s.other.push(ref); // producto sin semana (no es platillo del menú): no cuenta para mínimos
      } else {
        s.alc.qty += q; s.alc.lines.push(ref);
        s.alc.weeks[wid] = (s.alc.weeks[wid] || 0) + q;
      }
    });
    return s;
  }

  function findWeek(weeks, id) { return (weeks || []).filter(function (w) { return w.id === id; })[0] || null; }
  function weekText(weeks, id) { var w = findWeek(weeks, id); return w ? weekShort(w.monday) : 'una semana anterior'; }

  /* ---------- Progreso de un plan ---------- */
  // ctx.weeks: semanas visibles de Planes (PLAN_WINDOW). chosenIds: semanas que eligió el cliente (preferencia; el carrito manda).
  // keyOrCode: "BundleCode#n" o solo el BundleCode (= paquete 1).
  function planProgress(cart, keyOrCode, ctx, chosenIds) {
    var kx = splitPlanKey(keyOrCode);
    var code = kx.code, key = planKey(kx.code, kx.n);
    var cfg = parseBundleCode(code);
    if (!cfg) return null;
    var weeks = ctx.weeks;
    var pl = summarize(cart, weeks).plans[key] || { total: 0, perWeek: {}, lines: [] };
    var used = Object.keys(pl.perWeek).filter(function (id) { return pl.perWeek[id] > 0; }).sort();
    var usedIn = used.filter(function (id) { return findWeek(weeks, id); });
    var ids = planWeekIds(cfg, usedIn, chosenIds, weeks);
    var list = ids.map(function (id) { var w = findWeek(weeks, id); return { week: w, qty: pl.perWeek[id] || 0, need: cfg.perWeek }; });
    var active = -1;
    for (var i = 0; i < list.length; i++) { if (list[i].qty < list[i].need) { active = i; break; } }
    list.forEach(function (x, i) {
      x.status = x.qty >= x.need ? 'done' : (i === active ? 'open' : 'locked');
    });
    var outside = used.filter(function (id) { return ids.indexOf(id) === -1; });
    return {
      cfg: cfg, code: code, key: key, n: kx.n, total: pl.total, lines: pl.lines, weeks: list, activeIndex: active,
      weekIds: ids, startId: ids[0], usedWeeks: usedIn.length, outside: outside,
      complete: pl.total === cfg.total && outside.length === 0 && usedIn.length <= cfg.weeks && list.every(function (x) { return x.qty === x.need; })
    };
  }

  // Semanas del plan, en orden de fecha. Mandan las semanas que ya tienen platillos en el carrito;
  // después, las que el cliente eligió (preferencia); si faltan, se completan con las semanas
  // siguientes a la última conocida (por defecto, seguidas).
  function planWeekIds(cfg, usedIds, chosenIds, weeks) {
    var set = usedIds.slice();
    (chosenIds || []).forEach(function (id) {
      if (set.length < cfg.weeks && findWeek(weeks, id) && set.indexOf(id) === -1) set.push(id);
    });
    if (set.length < cfg.weeks) {
      var last = -1;
      weeks.forEach(function (w, i) { if (set.indexOf(w.id) > -1) last = Math.max(last, i); });
      var order = weeks.slice(last + 1).concat(weeks.slice(0, last + 1));
      for (var i = 0; i < order.length && set.length < cfg.weeks; i++) {
        if (set.indexOf(order[i].id) === -1) set.push(order[i].id);
      }
    }
    return set.sort();
  }

  // Semanas predeterminadas de un plan: las primeras N seguidas de la ventana.
  function defaultWeeks(cfg, weeks) {
    return weeks.slice(0, cfg.weeks).map(function (w) { return w.id; });
  }

  // Cuántos platillos más se pueden agregar al plan en una semana, y por qué no.
  function planAddLimit(cart, keyOrCode, weekId, ctx, chosenIds) {
    var p = planProgress(cart, keyOrCode, ctx, chosenIds);
    if (!p) return { max: 0, reason: 'invalid' };
    if (p.total >= p.cfg.total) return { max: 0, reason: 'plan_full', progress: p };
    var idx = -1;
    p.weeks.forEach(function (x, i) { if (x.week.id === weekId) idx = i; });
    if (idx < 0) return { max: 0, reason: 'outside', progress: p };
    var w = p.weeks[idx];
    if (w.qty >= w.need) return { max: 0, reason: 'week_full', progress: p };
    for (var j = 0; j < idx; j++) {
      if (p.weeks[j].qty < p.weeks[j].need) return { max: 0, reason: 'locked', blocking: p.weeks[j], progress: p };
    }
    return { max: Math.min(w.need - w.qty, p.cfg.total - p.total), reason: null, progress: p };
  }

  /* ---------- Validación del pedido completo ---------- */
  // ctx: { weeks: semanas de Planes (4), alcWeeks: semanas A la carta (4), current: semana en curso,
  //        at: instante a evaluar (opcional; por defecto ahora) }
  function validate(cart, ctx) {
    var weeks = ctx.weeks;
    var alcWeeks = ctx.alcWeeks || weeks.slice(0, ALC_WEEKS);
    var s = summarize(cart, weeks);
    var issues = [];

    if (!s.qty) return { ok: false, empty: true, issues: [{ type: 'empty', message: 'Tu pedido está vacío.' }], summary: s };

    if (s.express.qty && (s.alc.qty || s.planOrder.length || s.custom.qty)) {
      issues.push({ type: 'mix', message: 'Express va en un pedido aparte. Quita los platillos Express o los demás para poder pagar.' });
    }

    // Planes
    s.planOrder.forEach(function (key) {
      var pl = s.plans[key];
      var code = pl.code;
      if (!pl.cfg) {
        issues.push({ type: 'plan_invalid', code: code, key: key, message: 'Hay platillos de un plan que no reconocemos. Quítalos y vuelve a armar tu plan.' });
        return;
      }
      var p = planProgress(cart, key, ctx, null);
      var name = 'tu plan ' + pl.cfg.plan + (repeated(s, code) ? ' #' + pl.n : '');
      var past = Object.keys(pl.perWeek).filter(function (id) { return !findWeek(weeks, id); });
      if (past.length) {
        var future = weeks.length && past.every(function (id) { return id > weeks[weeks.length - 1].id; });
        issues.push({ type: 'past', kind: 'Planes', code: code, key: key, message: 'Una semana de ' + name + (future ? ' todavía no está disponible' : ' ya empezó') + '. Quita esos platillos de tu pedido para continuar.' });
        return;
      }
      if (p.usedWeeks > pl.cfg.weeks) {
        issues.push({ type: 'plan_weeks', code: code, key: key, message: name.charAt(0).toUpperCase() + name.slice(1) + ' es de ' + plural(pl.cfg.weeks, 'semana', 'semanas') + ', pero tiene platillos en ' + p.usedWeeks + '. Quita los de ' + weekText(weeks, p.weekIds[p.weekIds.length - 1]) + '.' });
        return;
      }
      var over = p.weeks.filter(function (x) { return x.qty > x.need; })[0];
      if (over) {
        issues.push({ type: 'plan_week_over', code: code, key: key, weekId: over.week.id, message: weekShort(over.week.monday).replace(/^l/, 'L') + ' de ' + name + ' tiene ' + dishes(over.qty - over.need) + ' de más.' });
        return;
      }
      if (pl.total < pl.cfg.total) {
        var open = p.weeks.filter(function (x) { return x.qty < x.need; })[0];
        var missing = pl.cfg.total - pl.total;
        issues.push({
          type: 'plan_incomplete', code: code, key: key, weekId: open && open.week.id, missing: missing,
          message: 'Te ' + (missing === 1 ? 'falta ' : 'faltan ') + dishes(missing) + ' para completar ' + name +
            (open && open.need - open.qty !== missing ? ' (' + dishes(open.need - open.qty) + ' en ' + weekShort(open.week.monday) + ').'
              : open ? ' en ' + weekShort(open.week.monday) + '.' : '.')
        });
      }
    });

    // CUSTOM 2027: cada platillo personalizado debe estar completo y en una semana disponible.
    var countsCustom = ctx.customCountsAlc != null ? ctx.customCountsAlc !== false : CUSTOM_COUNTS_ALC;
    s.custom.order.forEach(function (gid) {
      var g = s.custom.groups[gid];
      var broken = !g.dish || !gid || g.parts.length !== g.expected ||
        g.parts.some(function (p) { return p.qty !== g.qty || p.weekId !== g.weekId; });
      if (broken) {
        issues.push({ type: 'custom_broken', group: gid, message: 'Uno de tus platillos personalizados quedó incompleto. Quítalo y vuelve a armarlo.' });
      } else if (!findWeek(alcWeeks, g.weekId)) {
        issues.push({ type: 'past', kind: CUSTOM_KIND, group: gid, weekId: g.weekId, message: 'Tienes un platillo personalizado de una semana que ya no está disponible. Quítalo para continuar.' });
      }
    });

    // A la carta: mínimo 5 por cada semana con pedido (con personalizados si ctx.customCountsAlc no es false)
    var perWeek = {};
    Object.keys(s.alc.weeks).forEach(function (id) { perWeek[id] = (perWeek[id] || 0) + s.alc.weeks[id]; });
    if (countsCustom) Object.keys(s.custom.weeks).forEach(function (id) { perWeek[id] = (perWeek[id] || 0) + s.custom.weeks[id]; });
    var alcIds = Object.keys(perWeek).filter(function (id) { return perWeek[id] > 0; }).sort();
    alcIds.forEach(function (id) {
      if (!findWeek(alcWeeks, id)) {
        if (s.alc.weeks[id]) issues.push({ type: 'past', kind: 'A la carta', weekId: id, message: 'Tienes platillos a la carta de una semana que ya no está disponible. Quítalos para continuar.' });
        return;
      }
      var n = perWeek[id];
      if (n < MIN_ALC) {
        var m = MIN_ALC - n;
        var what = countsCustom && s.custom.weeks[id] ? ' entre a la carta y personalizados' : ' a la carta';
        issues.push({ type: 'alc_min', weekId: id, missing: m, message: 'Te ' + (m === 1 ? 'falta ' : 'faltan ') + dishes(m) + what + ' en ' + weekText(alcWeeks, id) + ' (mínimo ' + MIN_ALC + ').' });
      }
    });

    // Express: semana en curso y mínimo 5 en total
    if (s.express.qty) {
      var other = Object.keys(s.express.weeks).filter(function (id) { return ctx.current && id !== ctx.current.id; });
      var sched = expressSchedule(ctx.at);
      var dates = [];
      s.express.lines.forEach(function (l) {
        var f = props(l.item)['Fecha de entrega'];
        if (f && dates.indexOf(f) === -1) dates.push(f);
      });
      var badDay = dates.filter(function (iso) { return !sched.days.some(function (d) { return d.iso === iso && d.available; }); })[0];
      if (other.length) {
        issues.push({ type: 'past', kind: 'Express', message: 'Tienes platillos Express de otra semana. Quítalos para continuar.' });
      } else if (!sched.open) {
        issues.push({ type: 'express_closed', message: 'Express está cerrado en este momento (abre de lunes a viernes, hasta el viernes a las 3:00 p. m.). Quita los platillos Express para continuar.' });
      } else if (dates.length > 1) {
        issues.push({ type: 'express_days', message: 'Tus platillos Express tienen días de entrega distintos. Elige un solo día en Express.' });
      } else if (badDay) {
        issues.push({ type: 'express_day', message: 'La entrega Express del ' + longDay(parseIsoDate(badDay)) + ' ya no está disponible. Elige otro día en Express.' });
      } else if (s.express.qty < MIN_EXPRESS) {
        var e = MIN_EXPRESS - s.express.qty;
        issues.push({ type: 'express_min', missing: e, message: 'Te ' + (e === 1 ? 'falta ' : 'faltan ') + dishes(e) + ' Express para pedir (mínimo ' + MIN_EXPRESS + ').' });
      }
    }

    return { ok: issues.length === 0, empty: false, issues: issues, summary: s };
  }

  // ¿Se puede subir en 1 la cantidad de esta línea desde el resumen del pedido?
  function lineCanIncrease(cart, it, ctx) {
    var R = Rot();
    var kind = R.cartKind(it);
    if (kind === CUSTOM_KIND) return false; // CUSTOM 2027: la cantidad se cambia por platillo completo, no por línea
    if (kind === 'Planes') {
      var lim = planAddLimit(cart, linePlanKey(it), lineWeekId(it, ctx.weeks), ctx, null);
      return lim.max > 0;
    }
    if (kind === 'Express') return !!(ctx.current && lineWeekId(it, ctx.weeks) === ctx.current.id);
    return !!findWeek(ctx.alcWeeks || ctx.weeks.slice(0, ALC_WEEKS), lineWeekId(it, ctx.weeks));
  }

  /* ---------- Mezclas ---------- */
  // Devuelve null si se puede agregar, o qué tipo bloquea.
  function conflictFor(kind, cart) {
    var R = Rot();
    if (!R.mixError(kind, cart)) return null;
    return kind === 'Express' ? 'others' : 'express';
  }

  /* ---------- Descuentos de planes ---------- */
  // Con la matriz (página de Planes) o, sin ella, con el atributo guardado del carrito filtrado a los planes presentes.
  function discountCodes(cart, matrix) {
    var codes = [];
    var s = summarize(cart, []);
    var planCodes = [];
    s.planOrder.forEach(function (k) { var c = s.plans[k].code; if (planCodes.indexOf(c) === -1) planCodes.push(c); });
    if (matrix) {
      planCodes.forEach(function (bc) {
        var m = matrix[String(bc).toLowerCase()];
        if (m && m.code && codes.indexOf(m.code) === -1) codes.push(m.code);
      });
      return codes;
    }
    var allowed = planCodes.map(function (bc) { return 'BND-' + String(bc).toUpperCase(); });
    var attr = String(((cart && cart.attributes) || {})._ns_discount_codes || '');
    attr.split(',').map(function (c) { return c.trim(); }).forEach(function (c) {
      if (c && allowed.indexOf(c) > -1 && codes.indexOf(c) === -1) codes.push(c);
    });
    return codes;
  }

  // Porcentaje de descuento de una línea de plan: de la matriz (página de Planes) o, fuera de ella,
  // de la propiedad oculta "_ns_pct" que guarda la línea al agregarse (solo para mostrar).
  function linePercent(it, matrix) {
    if (Rot().cartKind(it) !== 'Planes') return 0;
    var code = String(props(it).BundleCode || '');
    if (matrix) { var m = matrix[code.toLowerCase()]; return (m && m.percent) || 0; }
    return parseFloat(props(it)._ns_pct) || 0;
  }

  // Ahorro estimado (centavos). El descuento final lo aplica el checkout.
  function estimateSavings(cart, matrix) {
    var s = summarize(cart, []);
    var total = 0;
    s.planOrder.forEach(function (k) {
      var pl = s.plans[k];
      var pc = pl.lines.length ? linePercent(pl.lines[0].item, matrix) : 0;
      if (!(pc > 0)) return;
      var base = pl.lines.reduce(function (sum, l) {
        var unit = typeof l.item.price === 'number' ? l.item.price : Math.round((l.item.line_price || 0) / l.qty);
        return sum + unit * l.qty;
      }, 0);
      total += Math.round(base * pc / 100);
    });
    return total;
  }

  // ¿Hay más de un paquete del mismo plan en el pedido?
  function repeated(s, code) {
    return s.planOrder.filter(function (k) { return s.plans[k].code === code; }).length > 1;
  }

  // Resumen visible para el pedido (atributo "Entregas"): qué paquete se entrega en qué semana y fechas.
  // Ej.: "Semana 45 · entrega 30 de octubre - 2 de noviembre: Plan Stronger #1 (5), A la carta (5)"
  function deliverySummary(cart, ctx) {
    var s = summarize(cart, ctx.weeks);
    var rows = {}, order = [];
    var add = function (id, label, qty) {
      if (!rows[id]) { rows[id] = []; order.push(id); }
      rows[id].push(label + ' (' + qty + ')');
    };
    s.planOrder.forEach(function (k) {
      var pl = s.plans[k];
      var label = 'Plan ' + (pl.cfg ? pl.cfg.plan : pl.code) + ' #' + pl.n;
      Object.keys(pl.perWeek).sort().forEach(function (id) { if (pl.perWeek[id]) add(id, label, pl.perWeek[id]); });
    });
    Object.keys(s.alc.weeks).sort().forEach(function (id) { if (s.alc.weeks[id]) add(id, 'A la carta', s.alc.weeks[id]); });
    Object.keys(s.custom.weeks).sort().forEach(function (id) { if (s.custom.weeks[id]) add(id, 'Personalizados', s.custom.weeks[id]); });
    var all = (ctx.weeks || []).concat(ctx.current ? [ctx.current] : []);
    var out = order.sort().map(function (id) {
      var w = findWeek(all, id);
      var head = w ? 'Semana ' + w.iso + ' · entrega ' + deliveryWindow(w.monday) : id;
      return head + ': ' + rows[id].join(', ');
    });
    if (s.express.qty) {
      var day = s.express.lines.map(function (l) { return props(l.item)['Fecha de entrega']; }).filter(Boolean)[0];
      out.push('Express · entrega ' + (day ? longDay(parseIsoDate(day)) : 'según hora del pedido') + ': ' + dishes(s.express.qty));
    }
    return out.join('\n');
  }

  /* ---------- Express ---------- */
  function expressDelivery(at) {
    var text = Rot().expressDeliveryText(at);
    var sameDay = /^Mismo día/.test(text);
    return {
      sameDay: sameDay,
      lineText: text,
      title: sameDay ? 'Pide antes de las 3:00 p. m. y te llega hoy' : 'Tu pedido llega mañana',
      text: sameDay ? 'Entrega el mismo día con Uber Delivery o DiDi Delivery.' : 'Ya pasó la hora de corte de hoy (3:00 p. m.). Programamos tu entrega para mañana.'
    };
  }

  /* ---------- Calendario Express: lunes a viernes, corte 3:00 p. m. (hora de Monterrey) ---------- */
  var EXPRESS_CUTOFF = 15 * 60;
  var DAY_SHORT = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie'];
  var DAY_LONG = ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'];
  var MONTH_LONG = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  // Fecha y hora de pared en Monterrey del instante "at" (sin depender de la zona del navegador).
  function mtyNow(at) {
    var f = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Monterrey', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false });
    var o = {};
    f.formatToParts(at || new Date()).forEach(function (p) { o[p.type] = p.value; });
    var y = +o.year, m = +o.month, d = +o.day;
    var dow = (new Date(Date.UTC(y, m - 1, d)).getUTCDay() + 6) % 7; // lunes = 0
    return { date: new Date(y, m - 1, d), dow: dow, minutes: ((+o.hour) % 24) * 60 + (+o.minute) };
  }
  function isoDate(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function parseIsoDate(s) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s || '')); return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null; }
  // "martes 28 de octubre"
  function longDay(d) { return DAY_LONG[(d.getDay() + 6) % 7] + ' ' + d.getDate() + ' de ' + MONTH_LONG[d.getMonth()]; }

  // Días de entrega Express de esta semana y si hoy se puede pedir.
  // reason del cierre: 'weekend' (sábado/domingo) o 'friday_late' (viernes desde las 3:00 p. m.).
  function expressSchedule(at) {
    var now = mtyNow(at);
    var monday = new Date(now.date.getFullYear(), now.date.getMonth(), now.date.getDate() - now.dow);
    var days = [];
    for (var i = 0; i < 5; i++) {
      var d = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + i);
      var state = i < now.dow ? 'past' : (i === now.dow && now.minutes >= EXPRESS_CUTOFF ? 'closed' : 'open');
      days.push({ date: d, iso: isoDate(d), short: DAY_SHORT[i], dayNum: d.getDate(), isToday: i === now.dow, state: state, available: state === 'open' });
    }
    var first = days.filter(function (x) { return x.available; })[0] || null;
    var reason = now.dow >= 5 ? 'weekend' : (!first ? 'friday_late' : null);
    return {
      days: days, open: !reason, reason: reason, first: first,
      minutesToCutoff: now.dow < 5 && now.minutes < EXPRESS_CUTOFF ? EXPRESS_CUTOFF - now.minutes : 0
    };
  }

  // Texto de la propiedad "Entrega" de una línea Express para el día elegido.
  function expressEntrega(iso, at) {
    var d = parseIsoDate(iso);
    if (!d) return Rot().expressDeliveryText(at);
    var today = isoDate(mtyNow(at).date) === iso;
    return (today ? 'Mismo día' : 'Programado') + ' (Uber Delivery / DiDi Delivery) – ' + longDay(d);
  }
  function expressDayLabel(iso, at) {
    var d = parseIsoDate(iso);
    if (!d) return '';
    return isoDate(mtyNow(at).date) === iso ? 'hoy' : 'el ' + longDay(d);
  }

  var api = {
    MIN_ALC: MIN_ALC, MIN_EXPRESS: MIN_EXPRESS, CUSTOM_KIND: CUSTOM_KIND, PLAN_WINDOW: PLAN_WINDOW, ALC_WEEKS: ALC_WEEKS, PLANS: PLANS,
    plural: plural, dishes: dishes,
    weeksForDays: weeksForDays, timeOptions: timeOptions, durationOptions: durationOptions, timesLabel: timesLabel,
    buildPlan: buildPlan, parseBundleCode: parseBundleCode,
    addWeeks: addWeeks, weekInfo: weekInfo, upcomingWeeks: upcomingWeeks, currentWeek: currentWeek,
    weekLabel: weekLabel, weekShort: weekShort, deliveryWindow: deliveryWindow, deliveryPhrase: deliveryPhrase,
    lineWeekId: lineWeekId, summarize: summarize, findWeek: findWeek,
    planProgress: planProgress, planAddLimit: planAddLimit, planWeekIds: planWeekIds, defaultWeeks: defaultWeeks,
    planKey: planKey, splitPlanKey: splitPlanKey, linePlanKey: linePlanKey, nextPlanNumber: nextPlanNumber,
    linePercent: linePercent, deliverySummary: deliverySummary,
    validate: validate, lineCanIncrease: lineCanIncrease, conflictFor: conflictFor,
    discountCodes: discountCodes, estimateSavings: estimateSavings, expressDelivery: expressDelivery,
    expressSchedule: expressSchedule, expressEntrega: expressEntrega, expressDayLabel: expressDayLabel,
    isoDate: isoDate, longDay: longDay
  };
  global.NSRules = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
